const apiUrl = process.env.REACT_APP_API_URL;

const getAreasBySiteID = (token, id, cb) => {
    fetch(`${apiUrl}/sites/${id}/areas`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getAreasBySiteID;
